export enum SolanaWalletType {
  Phantom = "Phantom",
  Solflare = "Solflare",
  Slope = "Slope",
}

export default class SolanaWallet {
  constructor(public type: SolanaWalletType, public address: string) {}
}

export function getSolanaWalletLogo(walletType: SolanaWalletType): any {
  switch(walletType) {
    case SolanaWalletType.Phantom: return require("@/assets/logos/wallets/phantom-logo.png");
    case SolanaWalletType.Solflare: return require("@/assets/logos/wallets/solflare-logo.png");
    case SolanaWalletType.Slope: return require("@/assets/logos/wallets/slope-logo.png");
  }
}